import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Toast } from "react-bootstrap";
import Cookies from "js-cookie";
import Cropper from "react-easy-crop";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import { InactivityContext } from "../../InactivityContext";
import AudioPlayer from "../../audioPlayer";
import Select from "react-select";
import { Spin } from "antd";
import { useCallContext } from "../../CallContext";
type OptionType = {
  value: number;
  label: string;
};


interface CallLog {
  agent_name: string;
  call_start_time_: string;
  call_end_time_: string;
  call_duration_hms: string;
  conversation_duration_hms: string;
  caller_status: string;
  destination_status: string;
  call_status: string;
  aws_call_recording_file: string;
  participant_name: string;
  phone_number: string;
}

interface Ticket {
  category?: number | null;
  subcategory?: number | null;
  priority?: number;
  description?: string;
  ticket_id?: number;
  call_back_time?: string | null;
}

type CardDetails = {
  id: number;
  mobile_number: string;
  alternate_mobile: string | null;
  student_name: string;
  parent_name: string;
  dob: string | null;
  gender_name: string;
  email: string;
  state: string;
  district: string | null;
  address: string;
  city: string;
  current_school: string;
  current_class: string;
  enrolling_class: string;
  source_name: string;
  status_name: string;
  has_ticket: boolean;
};

interface ErrorToast {
  key: string;
  message: string;
}

type TabType = {
  key: string;
  label: string;
  action?: string;
  subject?: string;
};


const PrismLeadTicket = () => {
  const route = all_routes;
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const s1 = Number(searchParams.get("s1"));
  const navigate = useNavigate();
  const [cardDetails, setCardDetails] = useState<CardDetails | null>(null);
  const [ticketLogs, setTicketLogs] = useState<any[]>([]);
  const { webApi, userPermissions } = useUserPermissions();
  const jwtToken = Cookies.get("authToken");
  const navigation = useNavigate();
  const [isLoading1, setIsLoading1] = useState(false);
  const [activeTab, setActiveTab] = useState("ticketLogs");
  const [ticketData, setTicketData] = useState<Ticket>({});
  const [categories, setCategories] = useState<{ id: number; name: string; is_callback_time: boolean }[]>([]);
  const [subcategories, setSubcategories] = useState<{ id: number; name: string }[]>([]);
  const [priorities, setPriorities] = useState<{ id: number; name: string }[]>([]);
  const categoryOptions: OptionType[] = categories.map((c) => ({ value: c.id, label: c.name, }));
  const subcategoryOptions: OptionType[] = subcategories.map((s) => ({ value: s.id, label: s.name, }));
  const priorityOptions: OptionType[] = priorities.map((p) => ({ value: p.id, label: p.name, }));
  const [expandedLogs, setExpandedLogs] = useState<{ [key: number]: boolean }>({});
  const [callLogs, setCallLogs] = useState<CallLog[]>([]);
  const [cardDetailsLoading, setCardDetailsLoading] = useState(false);
  const [ticketDataLoading, setTicketDataLoading] = useState(false);
  const [ticketLogsLoading, setTicketLogsLoading] = useState(false);
  const [callLogsLoading, setCallLogsLoading] = useState(false);
  const [callClickLoading, setCallClickLoading] = useState(false);
  const [ticketSaveLoading, setTicketSaveLoading] = useState(false);
  const [callDuration, setCallDuration] = useState(0);
  const [corelationId, setCorelationId] = useState("");
  const [intervalId, setIntervalId] = useState<NodeJS.Timeout | null>(null);
  const [errorToasts, setErrorToasts] = useState<ErrorToast[]>([]);
  const handleCloseToast = (index: number) => {
    setErrorToasts(prev => prev.filter((_, i) => i !== index));
  };
  useEffect(() => {
    if (errorToasts.length === 0) return;
    const timeoutId = setTimeout(() => {
      setErrorToasts(prev => prev.slice(1)); // remove oldest toast
    }, 6000);
    return () => clearTimeout(timeoutId);
  }, [errorToasts]);

  const inactivityContext = useContext(InactivityContext);
  if (!inactivityContext) {
    throw new Error("Header must be used within an InactivityProvider");
  }
  const { isCalling, setIsCalling } = useCallContext();
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const RightTabs: TabType[] = [
    { key: "call", label: "Call", action: "can_call", subject: "Call" },
    { key: "whatsapp", label: "WhatsApp", action: "can_whatapp", subject: "WhatsApp" },
    { key: "message", label: "Message", action: "can_message", subject: "Message" },
  ];

  const LeftTabs: TabType[] = [
    {
      key: "addTicket", label: cardDetails?.has_ticket ? "Update Ticket" : "Add Ticket",
      action: "change_schoolticket", subject: "schoolticket"
    },
    { key: "ticketLogs", label: "Ticket Logs", action: "view_schoolticketlog", subject: "schoolticketlog" },
    { key: "callLogs", label: "Call Logs", action: "view_calllog", subject: "calllog" },
  ];

  const Lefttabs = LeftTabs.filter(tab =>
    tab.action && tab.subject
      ? checkPermission(tab.action, tab.subject)
      : true
  );

  const Righttabs = RightTabs.filter(tab =>
    tab.action && tab.subject
      ? checkPermission(tab.action, tab.subject)
      : true
  );

  const handleCallClick = async () => {
    setCallClickLoading(true);
    try {
      const response = await fetch(
        `${webApi}/call/prism_school_calling/?call_participant_id=${id}`,
        options
      );

      if (response.status !== 200) {
        const errorJson = await response.json();
        const errorMessage = errorJson.detail || errorJson.error;
        console.log(errorMessage);
      } else {
        setIsCalling(true);
        setCallDuration(0);
        const corelationidData = await response.json();
        setCorelationId(corelationidData.correlationId);

        if (intervalId) {
          clearInterval(intervalId);
        }

        const id = setInterval(() => {
          setCallDuration((prev) => prev + 1);
        }, 1000);
        setIntervalId(id);

        checkCallEnd(corelationidData.correlationId);

        // **Make the second API call after the first call succeeds**
        await fetch(`${webApi}/user_monitoring/change_agent_status/3/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}), // Empty JSON object (not a string)
        });
      }
    } catch (error) { }
    finally {
      setCallClickLoading(false);
    }
  };

  const checkCallEnd = async (correlationId: any) => {
    try {
      const response = await fetch(
        `${webApi}/call/is_call_end/?correlation_id=${correlationId}`,
        options
      );
      const data = await response.json();

      if (data.is_call_end) {
        setIsCalling(false);
        await fetch(`${webApi}/user_monitoring/change_agent_status/1/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({}), // Empty JSON object (not a string)
        });
      } else {
        // setTimeout(() => checkCallEnd(correlationId), 1000);
      }
    } catch (error) {
      console.error("Error fetching call status:", error);

      // setTimeout(() => checkCallEnd(correlationId), 5000); // Retry after 5 seconds
    }
  };

  useEffect(() => {
    if (isCalling) {
      setTimeout(() => checkCallEnd(corelationId), 1000);
    }
  });

  const handleEndCallClick = async () => {
    setIsCalling(false);
    // Handle call end logic
    await fetch(`${webApi}/user_monitoring/change_agent_status/1/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({}), // Empty JSON object (not a string)
    });
  };


  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const handleTabClick = (tabKey: string) => {
    setActiveTab(tabKey);

    if (tabKey === "ticketLogs") {
      fetchTicketLogs();
    }

    if (tabKey === "callLogs") {
      fetchCallLogs();
    }
    if (tabKey === "call") {
      document.getElementById("openCallModalBtn")?.click();
    }
  };

  useEffect(() => {
    if (!checkPermission("view_schoollead", "schoollead")) {
      navigate("/login");
    } else {
      fetchTicketData();
      fetchCardDetails();
      // fetchTicketLogs();
      fetchCategories();
      fetchPriority();
    }
  }, [userPermissions]);

  useEffect(() => {
    if (ticketData?.ticket_id) {
      fetchTicketLogs();
    }
  }, [ticketData?.ticket_id]);
  const selectedCategory = categories.find(
    c => c.id === ticketData.category
  );
  const showCallback = selectedCategory?.is_callback_time;
  useEffect(() => {
    if (ticketData.category) {
      fetchSubCategories();

    }
  }, [ticketData.category]);

  const fetchCardDetails = async () => {
    setCardDetailsLoading(true);
    try {
      const response = await fetch(`${webApi}/school_leads/school_lead_card/${id}/`, options);
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setCardDetails(data);
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      setCardDetailsLoading(false);
    }
  };

  const fetchTicketData = async () => {
    setTicketDataLoading(true);
    try {
      const response = await fetch(`${webApi}/school_leads/school_ticket_operations/${id}/`, options);
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setTicketData(data);
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      setTicketDataLoading(false);
    }
  };

  const fetchTicketLogs = async () => {
    setTicketLogsLoading(true);
    try {
      const response = await fetch(`${webApi}/school_leads/get_teacher_ticket_logs_by_ticket/${ticketData.ticket_id}/`, options);
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setTicketLogs(data.results);
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      setTicketLogsLoading(false);
    }
  };

  const fetchCallLogs = async () => {
    setCallLogsLoading(true);
    try {
      const response = await fetch(`${webApi}/call/school_lead_wise_call_logs/${id}/`, options);
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setCallLogs(data.results);
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      setCallLogsLoading(false);
    }
  };

  const fetchCategories = async () => {
    // setCallLogsLoading(true);
    try {
      const response = await fetch(`${webApi}/school_leads/school_ticket_category_for_ticket_operations/`, options);
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      // setCallLogsLoading(false);
    }
  };

  const fetchSubCategories = async () => {
    // setCallLogsLoading(true);
    try {
      const response = await fetch(`${webApi}/school_leads/school_ticket_subcategory_dropdown_for_ticket_operations/?category=${ticketData.category}`, options);
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setSubcategories(data);
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      // setCallLogsLoading(false);
    }
  };

  const fetchPriority = async () => {
    // setCallLogsLoading(true);
    try {
      const response = await fetch(`${webApi}/school_leads/school_ticket_priority_dropdown_for_ticket_operations/`, options);
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/login");
        }
        throw new Error(errorData.detail || "Failed to fetch user data");
      }
      const data = await response.json();
      setPriorities(data);
    } catch (error) {
      console.error("Error fetching card details:", error);
    } finally {
      // setCallLogsLoading(false);
    }
  };

  const handleToggleLog = (index: number) => {
    setExpandedLogs((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const saveTicket = async () => {
    setTicketSaveLoading(true);
    try {
      let method1 = cardDetails?.has_ticket ? "PUT" : "POST";
      const requestOptions = {
        method: method1,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
        body: JSON.stringify(ticketData),
      };

      const response = await fetch(`${webApi}/school_leads/school_ticket_operations/${id}/`, requestOptions);

      if (!response.ok) {
        const errorData = await response.json();
        console.log("Error Data:", errorData);
        if (errorData.code === "token_not_valid") {
          navigate("/login");
          return;
        }
        const messages: ErrorToast[] = [];

        for (const key in errorData.results) {
          const value = errorData.results[key];
          if (Array.isArray(value)) {
            value.forEach((msg: string) => messages.push({ key, message: msg }));
          } else if (typeof value === "string") {
            messages.push({ key, message: value });
          }
        }
        setErrorToasts(messages);
        throw new Error("Network response was not ok");


      }



      fetchTicketLogs();
      return true;
    } catch (err) {
      console.error("Ticket save failed:", err);
      return false;
    }
    finally {
      setTicketSaveLoading(false);
    }
  };

  const handleSaveTicket = async () => {
    const success = await saveTicket();

    if (success) {
      setActiveTab("ticketLogs");
      // fetchTicketLogs();
      fetchCardDetails();
      fetchTicketData();
    }
  };

  const ringingAnimation = `
@keyframes ringing {
  0% { transform: translateY(0); }
  25% { transform: translateY(-2px); }
  50% { transform: translateY(2px); }
  75% { transform: translateY(-2px); }
  100% { transform: translateY(0); }
}
`;

  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(ringingAnimation, styleSheet.cssRules.length);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">
              {cardDetails?.has_ticket ? "Update Ticket" : "Add Ticket"}
            </h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <Link
                  to={s1 === 2 ? route.prismCompletedLeads : route.prismPendingLeads}
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  {s1 === 2 ? "completed leads" : "pending leads"}
                </Link>
                <li className="breadcrumb-item active" aria-current="page">
                  {cardDetails?.has_ticket ? "Update Ticket" : "Add Ticket"}
                </li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Main Layout */}
        <div className="row mt-3">

          {/* LEFT SIDEBAR → 4 cols */}
          <div className="col-md-3">
            <div className="settings-right-sidebar border-0">

              {/* Lead Info Card */}
              <div className="card">
                <div className="card-header">
                  <h5>Lead Information</h5>
                </div>

                <div className="card-body">

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Mobile Number:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.mobile_number || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Alternate Mobile:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.alternate_mobile || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Student Name:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.student_name || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Parent Name:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.parent_name || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Date of Birth:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.dob || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Gender:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.gender_name || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Email:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.email || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>State:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.state || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>District:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.district || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>City:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.city || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Address:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.address || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Current School:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.current_school || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Current Class:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.current_class || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Enrolling Class:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.enrolling_class || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #e5e7eb" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Source:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.source_name || "-"}</span>
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
                    <span style={{ fontWeight: "600", color: "#4b5563" }}>Status:</span>
                    <span style={{ textAlign: "right", color: "#1f2937" }}>{cardDetails?.status_name || "-"}</span>
                  </div>
                </div>
              </div>

              {/* Extra Sidebar Card */}
              {/* <div className="card mt-3">
                <div className="card-body">
                  
                </div>
              </div> */}

            </div>
          </div>

          {/* RIGHT CONTENT → 8 cols */}
          <div className="col-md-9">

            {/* MAIN CARD */}
            <div className="card">

              {/* HEADER WITH LEFT + RIGHT TABS */}
              <div
                className="card-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                {/* LEFT TABS */}
                <div style={{ display: "flex", gap: "10px" }}>
                  {Lefttabs.map((tab) => {
                    const isLoading =
                      tab.key === "addTicket" && ticketDataLoading ||
                      tab.key === "ticketLogs" && ticketLogsLoading ||
                      tab.key === "callLogs" && callLogsLoading;

                    return (
                      <div
                        key={tab.key}
                        onClick={() => handleTabClick(tab.key)}
                        style={{
                          padding: "6px 14px",
                          borderRadius: "6px",
                          border: "1px solid #e5e7eb",
                          cursor: "pointer",
                          background: activeTab === tab.key ? "#4f46e5" : "white",
                          color: activeTab === tab.key ? "white" : "#374151",
                          fontWeight: 500,
                        }}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <span>{tab.label}</span>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* RIGHT TABS */}
                <div style={{ display: "flex", gap: "10px" }}>
                  {Righttabs.map((tab) => {
                    const isLoading =
                      tab.key === "call" && callClickLoading;

                    return (
                      <div
                        key={tab.key}
                        onClick={() => handleTabClick(tab.key)}
                        style={{
                          padding: "6px 14px",
                          borderRadius: "6px",
                          border: "1px solid #e5e7eb",
                          cursor: "pointer",
                          background: activeTab === tab.key ? "#4f46e5" : "white",
                          color: activeTab === tab.key ? "white" : "#374151",
                          fontWeight: 500,
                        }}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <span>{tab.label}</span>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* CARD BODY CONTENT */}
              <div className="card-body">

                {activeTab === "addTicket" && (
                  // <div className="card">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSaveTicket();
                    }}
                  >
                    <div className="card-body">
                      <div className="row">

                        {/* Category */}
                        <div className="col-md-6 mb-3">
                          <strong>Category <span className="text-danger">*</span></strong>
                          <Select
                            options={categoryOptions}
                            placeholder="Search category..."
                            value={categoryOptions.find(o => o.value === ticketData.category) || null}
                            onChange={(opt) =>
                              setTicketData(prev => ({
                                ...prev,
                                category: opt ? opt.value : null,
                                subcategory: null
                              }))
                            }
                            isClearable
                            required
                          />
                        </div>

                        {showCallback && (
                          <div className="col-md-6 mb-3">
                            <label htmlFor="callbackTime" className="form-label">
                              <strong>
                                Call Back Date & Time <span className="text-danger">*</span>
                              </strong>
                            </label>

                            <input
                              id="callbackTime"
                              type="datetime-local"
                              className="form-control"
                              required
                              min={new Date().toISOString().slice(0, 16)}
                              value={
                                ticketData?.call_back_time
                                  ? new Date(ticketData.call_back_time)
                                    .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata" })
                                    .replace(" ", "T")
                                    .slice(0, 16)
                                  : ""
                              }
                              onChange={(e) =>
                                setTicketData((prev) => ({
                                  ...prev,
                                  call_back_time: e.target.value
                                    ? new Date(e.target.value).toISOString()
                                    : null,
                                }))
                              }
                            />
                          </div>
                        )}
                        {/* Subcategory */}
                        <div className="col-md-6 mb-3">
                          <strong>Subcategory <span className="text-danger">*</span></strong>
                          <Select
                            options={subcategoryOptions}
                            placeholder="Search subcategory..."
                            value={subcategoryOptions.find(o => o.value === ticketData.subcategory) || null}
                            onChange={(opt) =>
                              setTicketData(prev => ({
                                ...prev,
                                subcategory: opt ? opt.value : null
                              }))
                            }
                            isClearable
                            required
                          />
                        </div>

                        {/* Priority */}
                        <div className="col-md-6 mb-3">
                          <strong>Priority</strong>
                          <Select
                            options={priorityOptions}
                            placeholder="Search priority..."
                            value={priorityOptions.find(o => o.value === ticketData.priority) || null}
                            onChange={(opt) =>
                              setTicketData(prev => ({
                                ...prev,
                                priority: opt ? opt.value : undefined
                              }))
                            }
                            isClearable
                            required
                          />
                        </div>

                        {/* Description */}
                        <div className="col-md-12 mb-3">
                          <strong>Description</strong>
                          <textarea
                            className="form-control"
                            rows={3}
                            value={ticketData.description || ""}
                            onChange={(e) =>
                              setTicketData(prev => ({
                                ...prev,
                                description: e.target.value
                              }))
                            }
                          />
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                          <button className="btn btn-primary"
                          // onClick={handleSaveTicket}
                          >
                            {ticketSaveLoading ? (<i className="spinner-border spinner-border-sm"></i>) : (<span>Save</span>)}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  // </div>
                )}
                {activeTab === "ticketLogs" && (
                  // <div className="card">
                  ticketLogsLoading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "40px",
                      }}
                    >
                      <Spin />
                    </div>
                  ) : (
                    <div className="card-body">

                      <ul
                        className="timeline"
                        style={{
                          position: "relative",
                          paddingLeft: "0",
                          listStyle: "none",
                        }}
                      >
                        <div
                          style={{
                            content: "",
                            position: "absolute",
                            top: "0",
                            bottom: "0",
                            width: "4px",
                            background: "#e9ecef",
                            left: "50%",
                            marginLeft: "-2px",
                          }}
                        ></div>
                        {ticketLogs.map((log, index) => (
                          <li
                            key={index}
                            className={
                              index % 2 === 0 ? "" : "timeline-inverted"
                            }
                            style={{
                              position: "relative",
                              marginBottom: "10px",
                            }}
                          >
                            <div
                              className="card timeline-card"
                              style={{
                                background:
                                  index % 2 === 0 ? "#add8e6" : "#e6e6fa",
                                padding: "10px",
                                borderRadius: "95px",
                                cursor: "pointer",
                                overflowX: "auto",
                                // width: "auto",
                                // display: "inline-block",
                                // marginLeft: "50%", // Center the card
                                // transform: "translateX(-50%)",
                              }}
                              onClick={() => handleToggleLog(index)}
                            >
                              <div
                                className="timeline-heading"
                                style={{
                                  textAlign: "center",
                                  position: "relative",
                                  zIndex: "101",
                                  whiteSpace: "nowrap",
                                  overflowX: "auto",
                                }}
                              >
                                <h5
                                  className="timeline-title"
                                  style={{ margin: "0" }}
                                >
                                  {log.heading}
                                </h5>
                              </div>
                            </div>
                            {expandedLogs[index] && (
                              <div
                                className="timeline-panel"
                                style={{
                                  position: "relative",
                                  width: "100%",
                                  float: index % 2 === 0 ? "left" : "right",
                                  padding: "20px",
                                  border: "1px solid #d4d4d4",
                                  borderRadius: "2px",
                                  background: "#fff",
                                  boxShadow: "0 1px 6px rgba(0, 0, 0, 0.175)",
                                  overflowX: "auto",
                                }}
                              >
                                <div className="timeline-heading">
                                  <h4 className="timeline-title">
                                    {log.participant_name}
                                  </h4>
                                </div>
                                <div className="timeline-body">
                                  <table
                                    style={{
                                      width: "100%",
                                      tableLayout: "fixed",
                                      borderCollapse: "collapse",
                                    }}
                                  >
                                    <tbody>
                                      {log.description && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Description:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.description}
                                          </td>
                                        </tr>
                                      )}
                                      {log.category_name && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Category:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.category_name}
                                          </td>
                                        </tr>
                                      )}
                                      {log.subcategory_name && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Sub-Category:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.subcategory_name}
                                          </td>
                                        </tr>
                                      )}
                                      {log.ticket_type_name && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Ticket Type:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.ticket_type_name}
                                          </td>
                                        </tr>
                                      )}
                                      {log.priority_name && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Priority:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.priority_name}
                                          </td>
                                        </tr>
                                      )}
                                      {log.disposition_name && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Disposition:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.disposition_name}
                                          </td>
                                        </tr>
                                      )}
                                      {log.resolve_notes && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Resolve Notes:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.resolve_notes}
                                          </td>
                                        </tr>
                                      )}
                                      {log.remarks && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Remarks:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.remarks}
                                          </td>
                                        </tr>
                                      )}
                                      {log.call_back_time && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Call Back Time:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {new Date(
                                              log.call_back_time
                                            ).toLocaleString()}
                                          </td>
                                        </tr>
                                      )}
                                      {log.call_start_time && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Call Start Time:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {new Date(
                                              log.call_start_time
                                            ).toLocaleString()}
                                          </td>
                                        </tr>
                                      )}
                                      {log.updated_by_name && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Updated By:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {log.updated_by_name}
                                          </td>
                                        </tr>
                                      )}
                                      {log.updated_at && (
                                        <tr>
                                          <td
                                            style={{
                                              fontWeight: "bold",
                                              border: "1px solid #d4d4d4",
                                              whiteSpace: "nowrap",
                                              padding: "8px",
                                            }}
                                          >
                                            Updated At:
                                          </td>
                                          <td
                                            style={{
                                              border: "1px solid #d4d4d4",
                                              overflowX: "auto",
                                              padding: "8px",
                                            }}
                                          >
                                            {new Date(
                                              log.updated_at
                                            ).toLocaleString()}
                                          </td>
                                        </tr>
                                      )}
                                      {log.call_logs &&
                                        log.call_logs.map(
                                          (
                                            call: {
                                              aws_call_recording_file: string;
                                              caller_status: string;
                                              destination_status: string;
                                              call_start_time_:
                                              | string
                                              | number
                                              | Date;
                                              call_end_time_:
                                              | string
                                              | number
                                              | Date;
                                              agent_name:
                                              | string
                                              | number
                                              | boolean
                                              | React.ReactElement<
                                                any,
                                                | string
                                                | React.JSXElementConstructor<any>
                                              >
                                              | Iterable<React.ReactNode>
                                              | React.ReactPortal
                                              | null
                                              | undefined;
                                              call_duration_hms:
                                              | string
                                              | number
                                              | boolean
                                              | React.ReactElement<
                                                any,
                                                | string
                                                | React.JSXElementConstructor<any>
                                              >
                                              | Iterable<React.ReactNode>
                                              | React.ReactPortal
                                              | null
                                              | undefined;
                                              conversation_duration_hms:
                                              | string
                                              | number
                                              | boolean
                                              | React.ReactElement<
                                                any,
                                                | string
                                                | React.JSXElementConstructor<any>
                                              >
                                              | Iterable<React.ReactNode>
                                              | React.ReactPortal
                                              | null
                                              | undefined;
                                            },
                                            callIndex:
                                              | React.Key
                                              | null
                                              | undefined
                                          ) => {
                                            // Determine if the caller and destination answered
                                            const isCallerAnswered =
                                              call.caller_status.toLowerCase() ===
                                              "answered";
                                            const isDestinationAnswered =
                                              call.destination_status.toLowerCase() ===
                                              "answered";

                                            // Set badge color based on call status
                                            const badgeColor =
                                              isCallerAnswered &&
                                                isDestinationAnswered
                                                ? "success"
                                                : "danger";

                                            // Set icon based on whether the call was answered or not
                                            const agentIcon = isCallerAnswered
                                              ? "fas fa-phone text-success"
                                              : "fas fa-phone text-danger";
                                            const studentIcon =
                                              isDestinationAnswered
                                                ? "fas fa-phone text-success"
                                                : "fas fa-phone text-danger";

                                            return (
                                              <tr key={callIndex}>
                                                {call.call_start_time_ && (
                                                  <td
                                                    style={{
                                                      fontWeight: "bold",
                                                      border:
                                                        "1px solid #d4d4d4",
                                                      whiteSpace: "nowrap",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    Call Start:
                                                    <br />
                                                    <span
                                                      style={{
                                                        color: "green",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {new Date(
                                                        call.call_start_time_
                                                      ).toLocaleString()}
                                                    </span>
                                                  </td>
                                                )}
                                                {call.call_end_time_ && (
                                                  <td
                                                    style={{
                                                      fontWeight: "bold",
                                                      border:
                                                        "1px solid #d4d4d4",
                                                      whiteSpace: "nowrap",
                                                      padding: "8px",
                                                    }}
                                                  >
                                                    Call End:
                                                    <br />
                                                    <span
                                                      style={{
                                                        color: "red",
                                                        fontWeight: "bold",
                                                      }}
                                                    >
                                                      {new Date(
                                                        call.call_end_time_
                                                      ).toLocaleString()}
                                                    </span>
                                                  </td>
                                                )}
                                                <td
                                                  style={{
                                                    border:
                                                      "1px solid #d4d4d4",
                                                    padding: "8px",
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "inline-block",
                                                      marginRight: "30px",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <h4 className="timeline-title">
                                                      {call.agent_name}{" "}
                                                      <i
                                                        className={agentIcon}
                                                      ></i>
                                                    </h4>
                                                    {call.call_duration_hms && (
                                                      <p
                                                        style={{
                                                          color: "orange",
                                                          marginBottom: "3px",
                                                        }}
                                                      >
                                                        {
                                                          call.call_duration_hms
                                                        }
                                                      </p>
                                                    )}
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "inline-block",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    <h5 className="timeline-title">
                                                      PARENT{" "}
                                                      <i
                                                        className={
                                                          studentIcon
                                                        }
                                                      ></i>
                                                    </h5>
                                                    {call.conversation_duration_hms && (
                                                      <p
                                                        style={{
                                                          color: "orange",
                                                        }}
                                                      >
                                                        {
                                                          call.conversation_duration_hms
                                                        }
                                                      </p>
                                                    )}
                                                  </div>
                                                  {call.aws_call_recording_file && (
                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "flex-end",
                                                        marginTop: "10px", // Optional: Adds some spacing above the audio player
                                                      }}
                                                    >
                                                      <AudioPlayer
                                                        src={
                                                          call.aws_call_recording_file
                                                        }
                                                      />
                                                    </div>
                                                  )}
                                                </td>
                                              </tr>
                                            );
                                          }
                                        )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                      {/* </div> */}
                    </div>
                  )
                )}
                {activeTab === "callLogs" &&
                  (
                    // <div className="card">
                    callLogsLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "40px",
                        }}
                      >
                        <Spin />
                      </div>
                    ) : (
                      <div className="card-body">
                        <ul className="timeline">
                          {callLogs.map((call, index) => {
                            const isCallerAnswered =
                              call.caller_status.toLowerCase() === "answered";
                            const isDestinationAnswered =
                              call.destination_status.toLowerCase() ===
                              "answered";
                            const badgeColor =
                              isCallerAnswered && isDestinationAnswered
                                ? "success"
                                : "danger";
                            const agentIcon = isCallerAnswered
                              ? "fas fa-phone text-success"
                              : "fas fa-phone text-danger";
                            const studentIcon = isDestinationAnswered
                              ? "fas fa-phone text-success"
                              : "fas fa-phone text-danger";

                            return (
                              <li
                                key={index}
                                className={
                                  index % 2 === 0 ? "" : "timeline-inverted"
                                }
                              >
                                <div className={`timeline-badge ${badgeColor}`}>
                                  <i className="fas fa-phone" />
                                </div>
                                <div
                                  className="timeline-panel"
                                  style={{
                                    boxShadow:
                                      "0px 4px 10px rgba(0, 0, 0, 0.1)", // Shadow effect
                                    borderRadius: "5px", // Optional: Rounds the corners of the card
                                  }}
                                >
                                  <div className="timeline-heading">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {call.call_start_time_ && (
                                        <span
                                          style={{
                                            color: "green",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {new Date(
                                            call.call_start_time_
                                          ).toLocaleString()}
                                        </span>
                                      )}
                                      {call.call_end_time_ && (
                                        <span
                                          style={{
                                            color: "red",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {new Date(
                                            call.call_end_time_
                                          ).toLocaleString()}
                                        </span>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "inline-block",
                                          marginRight: "30px",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h4 className="timeline-title">
                                          {call.agent_name}{" "}
                                          <i className={agentIcon}></i>
                                        </h4>
                                        {call.call_duration_hms && (
                                          <p
                                            style={{
                                              color: "orange",
                                              marginBottom: "3px",
                                            }}
                                          >
                                            {call.call_duration_hms}
                                          </p>
                                        )}
                                      </div>
                                      <div
                                        style={{
                                          display: "inline-block",
                                          textAlign: "center",
                                        }}
                                      >
                                        <h5 className="timeline-title">
                                          PARENT <i className={studentIcon}></i>
                                        </h5>
                                        {call.conversation_duration_hms && (
                                          <p style={{ color: "orange" }}>
                                            {call.conversation_duration_hms}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="timeline-body">
                                    {call.aws_call_recording_file && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <AudioPlayer
                                          src={call.aws_call_recording_file}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    ))}
                {activeTab === "call" && <div>Call Panel</div>}
                {activeTab === "whatsapp" && <div>WhatsApp Chat</div>}
                {activeTab === "message" && <div>SMS Message</div>}

              </div>
              {isCalling && (
                <div
                  style={{
                    position: "fixed",
                    top: "10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                    padding: "20px",
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    fontSize: "1.2em",
                    animation: "ringing 1s infinite",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "15px",
                    }}
                  >
                    <i
                      className="ti ti-phone"
                      style={{
                        fontSize: "1.5em",
                        color: "blue",
                        marginRight: "5px",
                        animation: "ringing 1s infinite",
                      }}
                    ></i>
                    <span style={{ animation: "ringing 1s infinite" }}>
                      Calling to {cardDetails?.student_name} - {Math.floor(callDuration / 60)}:
                      {("0" + (callDuration % 60)).slice(-2)}
                    </span>
                  </div>
                  <button
                    className="btn btn-danger"
                    style={{ backgroundColor: "#dc3545", color: "white" }}
                    onClick={handleEndCallClick}
                  >
                    <i
                      className="ti ti-phone-off"
                      style={{ fontSize: "1.5em" }}
                    ></i>{" "}
                    End Call
                  </button>
                </div>
              )}
            </div>
          </div>
          <div
            className="modal fade"
            id="call_confirmation_modal"
            // tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Confirm Call</h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="ti ti-x" />
                  </button>
                </div>
                <div className="modal-body">
                  {/* <div className="mb-3">
                  <label>Select Number</label>
                  <select
                    className="form-select"
                    value={selectedCallId}
                    onChange={(e) => setSelectedCallId(e.target.value)}
                  >
                    <option value="">Select contact</option>
                    {callOptions.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div> */}
                  <p>Are you sure you want to make this call?</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-bs-dismiss="modal"
                    style={{ marginRight: "9px" }}
                  >
                    No
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-dismiss="modal"
                    onClick={handleCallClick}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button
            id="openCallModalBtn"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#call_confirmation_modal"
            style={{ display: "none" }}
          >
            open
          </button>
          <div
            className="position-fixed top-0 end-0 right-0 p-3"
            style={{ zIndex: 9999 }}
          >
            {errorToasts.map((toast, index) => (
              <Toast
                key={index}
                show={true}
                onClose={() => handleCloseToast(index)}
                className="colored-toast bg-danger-transparent mb-2"
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <Toast.Header closeButton className="bg-danger text-white">
                  <strong className="me-auto text-capitalize">
                    {toast.key}
                  </strong>
                </Toast.Header>
                <Toast.Body>{toast.message}</Toast.Body>
              </Toast>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrismLeadTicket;
